import { render, staticRenderFns } from "./CowsDehorningFirstPage.vue?vue&type=template&id=9d479fee&scoped=true&"
import script from "./CowsDehorningFirstPage.vue?vue&type=script&lang=js&"
export * from "./CowsDehorningFirstPage.vue?vue&type=script&lang=js&"
import style0 from "./CowsDehorningFirstPage.vue?vue&type=style&index=0&id=9d479fee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d479fee",
  null
  
)

export default component.exports